(function (window) {
    const testId = 'AB-018';
    const variantId = 'variant-1';
  
    waitFor(pageReady, 20000)
      .then(runVariant)
      .catch((err) => console.error(testId, err));
  
    function runVariant(cartHeader) {
      if (window.AB_018 === 1) return;
  
      window.AB_018 = 1;
      addBanner(cartHeader);
      document.body.classList.add(testId);
      console.log(`${testId}: ${variantId}`);
    }
  
    function addBanner(cartHeader) {
      const html = `
        <div id="${testId}-banner">
          <p class="${testId}-top">Congratulations!</p>
          <p class="${testId}-middle">Your order will ship to you for free.</p>
          <div class="${testId}-bar"><p class="${testId}-bar_text">free shipping</p></div>
        </div>`;
  
      cartHeader.insertAdjacentHTML('afterend', html);
    }
  
    function pageReady() {
      return document.querySelector('#slidecarthq .slidecarthq header');
    }
  
    function waitFor(condition, timeout) {
      const stopTime = typeof timeout === 'number' ? timeout : 7000;
      let stop = false;
  
      window.setTimeout(function () {
        stop = true;
      }, stopTime);
  
      // eslint-disable-next-line no-undef
      return new Promise(function (resolve, reject) {
        (function _innerWaitFor() {
          const value = condition();
  
          if (stop) {
            reject();
          } else if (value) {
            resolve(value);
          } else {
            window.setTimeout(_innerWaitFor, 50);
          }
        })();
      });
    }
  })(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);
  // eslint-disable-next-line spaced-comment
  //# sourceURL=AB-018-variant-1.js